import AuthNavigator from './AuthNavigator'

export default AuthNavigator
